<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BthPlh/tc-custom/9781455609888.jpg?1705766095153" alt="This image is the cover for the book Old Louisiana"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Old Louisiana
      </h1>
      <p class="bookDescription body article font2">
        <p>A fascinating volume, Old Louisiana chronicles much of the state's history. Vignettes depict the early French settlers, the later Spanish rulers, and the rise and collapse of the great plantation era.</p><p>Bringing to light old diaries, letters, and other rare sources, Saxon creates a sensitive and realistic portrait of this charming, colorful state and its people. The reader meets daring pioneers, hot-tempered duellists, aristocratic planters, rough-hewn river men, and Creole beauties. </p><p>Both of these classic works include E. H. Suydam's haunting, detailed illus-trations, which bring Saxon's prose to life. Lyle Saxon (1891-1946) is renowned as one of Louisiana's foremost authors. He was the central figure in the state's literary community during the 1920s and 1930s, and was well-known as a raconteur and bon vivant. He divided his time between his house in New Orleans and a cottage on the Melrose Plantation near Nachitoches. Among his other works are Father Mississippi, Lafitte the Pirate, Children of Strangers, and Joe Gilmore and His Friends . He collaborated with Edward Dreyer and Robert Tallant on the perennial favorite Gumbo Ya-Ya . During the 1930s he headed the Louisiana WPA Writers Project, which produced the WPA Guide to Louisiana and the WPA Guide to New Orleans.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lyle Saxon
      </h2>
      
      <p class="authorDescription body article">Lyle Saxon (1891-1946) ranks among Louisiana's most outstanding writers. During the 1920s and 1930s he was the central figure in the regionís literary community, and was widely known as a raconteur and bon vivant. In addition to Father Mississippi, Lafitte the Pirate, and Children of Strangers, he also wrote Fabulous New Orleans, Old Louisiana, The Friends of Joe Gilmore, and was a co-author of Gumbo Ya-Ya,  with Edward Dreyer and Robert Tallant. During the Depression, he directed the state WPA Writers Project, which produced the WPA Guide to Louisiana and the WPA Guide to New Orleans.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Craeger
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?04357c0c